import { useCallback } from "react";
import { useNotification } from "@/context/NotificationContext";

/** Stable callback for `useApiCall` / similar `onError` handlers. */
export function useApiErrorNotify() {
  const { notify } = useNotification();
  return useCallback((message: string) => notify(message, "error"), [notify]);
}
